import { Offer } from '../../core/models/offer/offer.model';
import { QueryParamsModel } from './query-params.model';
import { CalculationState } from '../../core/models/calculation-state';
import { ProcessContext } from './request-offer/request-header.model';
import { OffersState } from './offers-state.model';
import { SectionState } from '../services/sections-state.service';
import { AppMode } from './app-mode.enum';
import { RegistrationState } from './registration-state';
import { NavigationState } from './navigation-state';
import {InsuranceCoverageModel} from '../../core/models/insurance-coverage.model';
import {PostalCodesState} from './postal-codes-state';
import {OfferModification} from '../../core/models/offer/offer-modification.model';
import {CalculationData} from '../../core/models/calculation-data.model';
import {OfferResponseStatusCode} from '../../core/enums/offer/offer-response-status-code.enum';

export class ApplicationState {

  calculationState: CalculationState;
  selectedOffer: Offer;
  selectedOfferNotModified: Offer;
  selectedOfferStatusCode: OfferResponseStatusCode;
  queryParams: QueryParamsModel; // query params stored in storage
  processContext: ProcessContext;
  offersState: OffersState;
  salesChannel: string;
  dirtyFields: {[key: string]: boolean};
  mode: AppMode;
  offerPackageName: string;
  cessionPostalCode: string;
  registrationState: RegistrationState;
  dataFromAztec: boolean = false;
  calculationDataFromSession: boolean = false;
  navigationState: NavigationState;
  sectionsState: SectionState[];
  entryWithSessionId: boolean = false;
  usedPreviewMode: boolean = false;
  bankierIdSalesChannelBankier: string; // analytics parameter generated by Bankier
  insuranceCoverages: InsuranceCoverageModel;
  unknownRegistrationNumber: boolean;
  urlCalculationParamInserted: boolean;
  noDrivingLicense: boolean;
  registrationNumberFromSession: string; // used for offer-pay event payload after payment acceptance
  postalCodes: PostalCodesState; // used for resetting address data in offer matching mode
  enginePower: string;
  aztecScannedFromQrCode: boolean;
  selectedOfferOriginalModifications: OfferModification[];
  separateInsurer: boolean;
  dataFromCalculationCache: boolean;
  entryUrl: string;
  redirectedToPayment: boolean = false;
  endInsuranceDate: Date;
  selectedPremiumCode: string;
  sessionCalculationData: CalculationData;

  constructor() {
    this.processContext = new ProcessContext();
    this.offersState = new OffersState();
    this.dirtyFields = {};
    this.navigationState = {};
    this.insuranceCoverages = new InsuranceCoverageModel(true);
    this.postalCodes = {};
  }
}
